module.exports = __webpack_public_path__ + "8a5356e9/img/splash-icon.07a7c465.svg";